
  import { Component, Vue ,Prop,Inject,Watch} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  import {
    imgHost
  } from "@/utils/config"
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:''}) modekey!:''
    private imgHost = imgHost
    private titleImg = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/d0d1855b5c7ce64d8036efa793e4da6.png'
    private subjectImg = 'http://routuan2022.oss-cn-hangzhou.aliyuncs.com/routuan/image/31dd1a4f57b1bf324e6555e855666d3.png'
    @Inject() information:any
    get value(){
      // console.log(this.information)
      return this.information
    }
    @Inject() editinfo:any
    get editmsg(){
      let msg = this.information.find(v=>{
        return v.key == this.modekey
      })
      // console.log(msg)
      return msg
    }
  }
